import * as React from 'react';
import { FactureOpenSearch } from '@europrocurement/l2d-domain';
import ActionMenuListeFacture from './ActionMenu/ActionMenuListeFacture';

const CustomActionsColumn: React.FunctionComponent<{ item: FactureOpenSearch }> = function ({
    item,
}) {
    return <ActionMenuListeFacture facture={item} />;
};

export default CustomActionsColumn;
